import { AuthAction } from '../../actions/auth/AuthAction'
import {IAuthState} from './IAuthState'
import AuthActionTypes from '../../actions/auth/AuthActionTypes'

export const initialState: IAuthState = {
  isLogged:     false,
  isRequesting: false,
}

export const AuthReducer = function auth(state: IAuthState = {...initialState}, action: AuthAction): IAuthState {
  switch (action.type) {
    case AuthActionTypes.SET_IS_LOGGED: {
      return {
        ...state,
        isLogged: true,
      }
    }
    case AuthActionTypes.REQUEST_LOGIN: {
      return {
        ...state,
        isRequesting: true,
        error: undefined,
      }
    }
    case AuthActionTypes.REQUEST_LOGIN_SUCCESS: {
      return {
        ...state,
        isLogged: true,
        isRequesting: false,
      }
    }
    case AuthActionTypes.REQUEST_LOGIN_FAILURE: {
      return {
        ...state,
        isRequesting: false,
        error: action.payload.error,
      }
    }
    case AuthActionTypes.LOGOUT: {
      return {
        ...state,
        isLogged: false,
      }
    }
    default:
      return state
  }
}

